import { createStore } from 'vuex'

export default createStore({
    state: {
        payInfo: {}
    },
    mutations: {
        updatePayInfo(state, data){
            state.payInfo = data
            console.log("mutations updatePayInfo", state.payInfo)
        },
        removePayInfo(state) {
            state.payInfo = {}
        },
    },
    getters: {

    },
    actions: {
        setPayInfo: ({commit}, data) => {
            console.log('commit setPayInfo', data)
            commit('updatePayInfo', data);
        },
        removePayInfo: ({commit}) => {
            commit('removePayInfo');
        }
    },
    modules: {},
})